import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"apple"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 12.4997C21 16.4187 18.5039 20.0039 15.5 20.9879C14.0008 21.479 13.5024 20.4997 12 20.4997C10.4976 20.4997 9.99914 21.4812 8.5 20.9879C5.5035 20.0017 3 16.4187 3 12.4997C3 9.37809 4.24905 6.99933 6.5 5.74965C8.75095 4.49997 10.151 5.49965 12 5.49965C13.8482 5.49965 15.25 4.50342 17.5 5.74959C19.75 6.99577 21 9.37731 21 12.4997Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 8.46484C11.2238 9.17263 12.7757 9.17263 13.9995 8.46484M11.9998 8.5V3M21 12.4997C21 9.37731 19.75 6.99577 17.5 5.74959C15.25 4.50342 13.8482 5.49965 12 5.49965C10.151 5.49965 8.75095 4.49997 6.5 5.74965C4.24905 6.99933 3 9.37809 3 12.4997C3 16.4187 5.5035 20.0017 8.5 20.9879C9.99914 21.4812 10.4976 20.4997 12 20.4997C13.5024 20.4997 14.0008 21.479 15.5 20.9879C18.5039 20.0039 21 16.4187 21 12.4997Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Apple = Vue.extend<IconProps>({
  name: 'AppleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'apple',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Apple;
